function n(n){return"banner"===n.recommendationType}export{n as isBannerRecommendation};
//# sourceMappingURL=guards.js.map
